// extracted by mini-css-extract-plugin
module.exports = {"exploreWrap":"Explore_exploreWrap__DQX2P","gridWrap":"Explore_gridWrap__2Cfr9","detailBlock":"Explore_detailBlock__2wi9F","contentWrap":"Explore_contentWrap__1Upll"};